import React from 'react';
import './ContentContainer.sass'
import {Grid, useMediaQuery, useTheme} from "@mui/material";

function ContentContainer({header, children}) {
    const theme = useTheme();
    const isMobile = useMediaQuery(theme.breakpoints.down("md"));

    return (
        <div className={isMobile ? "content_container_mobile" : "content_container"}>
            <Grid container>
                <Grid item xs={12}>
                    <h1 className="content_container__header">{header}</h1>
                </Grid>

                <Grid item xs={12}>
                    <hr />
                </Grid>

                <Grid container>
                    <Grid item md={1} sx={{ display: { md: 'block', xs: 'none' } }} />
                    <Grid item xs={12} md={10}>
                        {children}
                    </Grid>
                    <Grid item md={1} sx={{ display: { md: 'block', xs: 'none' } }} />
                </Grid>
            </Grid>
        </div>
    );
}

export default ContentContainer;